<template>
    <div>
        <h2 class="clickable" :class="{'collapsed-heading': !expanded}" @click="expanded=!expanded">
            NHVAS History
            <v-icon v-if="expanded">arrow_drop_up</v-icon>
            <v-icon v-else>arrow_drop_down</v-icon>
        </h2>
        <v-expand-transition>
            <nhvas-history-list v-show="expanded" :unit="unit"></nhvas-history-list>
        </v-expand-transition>
    </div>
</template>
<script>
import NhvasHistoryList from '@/components/Units/Details/NhvasHistory/NhvasHistoryList';

export default {
    props: {
        unit: { required: true }
    },
    components: {
      NhvasHistoryList,
    },
    data: () => {
        return {
            expanded: false
        };
    }
};
</script>
